import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import Ripple from 'vuetify/lib/directives/ripple';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.isMobile && _setup.doctor
    ? _c(
        VExpansionPanel,
        { staticClass: "expansion-panel elevation-0" },
        [
          _c(
            VExpansionPanelHeader,
            {
              staticClass: "px-2",
              attrs: { "expand-icon": "ui-icon-arrow-down" },
            },
            [
              _c("div", { staticClass: "d-flex" }, [
                _c("div", { staticClass: "lpu-order text-subtitle-1" }),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("div", { staticClass: "text-subtitle-1" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _setup.transDynamic(
                              _vm.lpuAddress.lpu,
                              `name,${_setup.currentLanguageIso},${_setup.needTranslate}`
                            )
                          ) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _setup.filterType !== "telemed"
                      ? [
                          _c(VExpandTransition, [
                            !_vm.isExpanded
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-body-2 text-secondary--text",
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_setup.fullAddress) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            VExpansionPanelContent,
            [
              _vm.lpuAddress.has_restriction_appointment
                ? _c(_setup.AppointmentRestrictionsBanner, {
                    staticClass: "mb-3",
                    on: {
                      "open-appointment-restrictions": function ($event) {
                        return _setup.emit(
                          "open-appointment-restrictions",
                          _vm.lpuAddress.lpu
                        )
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _setup.workplaces.length || _setup.services.length
                ? _c(_setup.WorkplaceOrServiceSelect, {
                    attrs: {
                      "lpu-id": _vm.lpuAddress.lpu.id,
                      "data-lpu-addr-id": _vm.lpuAddress.id,
                      "init-speciality-translit": _setup.doctor.spec.translit,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(_setup.DoctorPriceBlock, {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _setup.filterType !== "home",
                    expression: "filterType !== 'home'",
                  },
                ],
                staticClass: "mt-4",
                attrs: {
                  "page-type": _setup.filterType,
                  price:
                    _setup.selectedItemPriceList[
                      _setup.defaultPricePropertyName
                    ],
                  "club-price": _setup.selectedItemPriceList.priceClub,
                  "telemed-medtochka-price":
                    _setup.selectedItemPriceList.priceMedtochkaTelemed,
                  "tab-is-free-with-treatment":
                    _setup.selectedItem.workplace?.tab_is_free_with_treatment,
                  "speciality-selected": "",
                },
                on: {
                  "update:redirect-value":
                    _setup.handlePriceBlockUpdateRedirectValue,
                },
              }),
              _vm._v(" "),
              _vm.lpuAddress.lpu.lpu_loyalty_program &&
              _setup.filterType === "clinic"
                ? _c(_setup.LpuLoyaltyProgram, {
                    staticClass: "my-3",
                    attrs: {
                      "bonus-levels":
                        _vm.lpuAddress.lpu.lpu_loyalty_program.levels,
                      "max-payment-percent":
                        _vm.lpuAddress.lpu.lpu_loyalty_program
                          .max_payment_percent,
                      "welcome-bonus-amount":
                        _vm.lpuAddress.lpu.lpu_loyalty_program
                          .welcome_bonus_amount,
                      "use-label": "",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _setup.workplaces.length || _setup.services.length
                ? _c(_setup.WorkplaceOrServiceCalendar, {
                    staticClass: "mt-3 mb-10",
                    attrs: { "lpu-address": _vm.lpuAddress },
                  })
                : _vm._e(),
              _vm._v(" "),
              _setup.filterType !== "telemed"
                ? [
                    _c(
                      "div",
                      {
                        directives: [{ def: Ripple, name: "ripple", rawName: "v-ripple" }],
                        staticClass:
                          "d-flex align-center text-body-1 py-2 cursor-pointer",
                        on: { click: _setup.handlePopupMapButtonClick },
                      },
                      [
                        _c(
                          VIcon,
                          {
                            staticClass: "mr-4",
                            attrs: { size: "20", color: "icon-secondary" },
                          },
                          [_vm._v("\n          ui-icon-map-pin\n        ")]
                        ),
                        _vm._v(
                          "\n        " +
                            _vm._s(_setup.fullAddress) +
                            "\n        "
                        ),
                        _c(VSpacer),
                        _vm._v(" "),
                        _c(VIcon, [
                          _vm._v("\n          ui-icon-arrow-right\n        "),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.lpuAddress.lpu.lpumetro_set.all.length
                      ? _c(_setup.DoctorPageLpuListMetroList, {
                          staticClass: "mt-2",
                          attrs: { "lpu-address": _vm.lpuAddress },
                        })
                      : _vm._e(),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(_setup.DoctorPageLpuListPhone, {
                attrs: { "lpu-address": _vm.lpuAddress },
              }),
              _vm._v(" "),
              _c(
                "a",
                {
                  directives: [{ def: Ripple, name: "ripple", rawName: "v-ripple" }],
                  staticClass:
                    "d-flex align-center text-decoration-none text-body-1 py-2 mt-2",
                  attrs: { href: _setup.lpuUrl },
                },
                [
                  _c(
                    VIcon,
                    {
                      staticClass: "mr-4",
                      attrs: { size: "20", color: "icon-secondary" },
                    },
                    [_vm._v("\n        ui-icon-home-ProDoctorov\n      ")]
                  ),
                  _vm._v(
                    "\n      " +
                      _vm._s(_setup.t("Страница клиники", _setup.options)) +
                      "\n      "
                  ),
                  _c(VSpacer),
                  _vm._v(" "),
                  _c(VIcon, [
                    _vm._v("\n        ui-icon-arrow-right\n      "),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _setup.isBannerMtLinkVisible
                ? _c(_setup.BannerMtLink, {
                    staticClass: "mt-4",
                    attrs: {
                      text: _setup.t(
                        "К врачу можно приходить с электронной медкартой",
                        _setup.options
                      ),
                    },
                  })
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      )
    : _setup.doctor
    ? _c(
        "div",
        { staticClass: "doctor-page-list-lpu pa-6" },
        [
          _setup.isBannerMtLinkVisible
            ? _c(_setup.BannerMtLink, {
                staticClass: "mb-6",
                attrs: {
                  text: _setup.t(
                    "К врачу можно приходить с электронной медкартой",
                    _setup.options
                  ),
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex" },
            [
              _c(
                VSheet,
                { staticClass: "d-flex flex-column", attrs: { width: "336" } },
                [
                  _c(
                    "a",
                    {
                      staticClass:
                        "text-subtitle-1 primary--text text-decoration-none",
                      attrs: { href: _setup.lpuUrl },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _setup.transDynamic(
                            _vm.lpuAddress.lpu,
                            `name,${_setup.currentLanguageIso},${_setup.needTranslate}`
                          )
                        )
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _setup.isUserStaff
                    ? _c("div", { staticClass: "mt-4" }, [
                        _c(
                          "a",
                          {
                            staticClass: "adminka",
                            attrs: {
                              href: `${_setup.urls?.problemsWithSlots}?lpu_id=${_vm.lpuAddress.lpu.id}&doctor_id=${_vm.lpuAddress.doctor_id}`,
                              target: "_blank",
                              rel: "noopener noreferrer",
                            },
                          },
                          [_vm._v("Проблемы с расписанием")]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.lpuAddress.has_restriction_appointment
                    ? _c(_setup.AppointmentRestrictionsBanner, {
                        staticClass: "mt-6",
                        on: {
                          "open-appointment-restrictions": function ($event) {
                            return _setup.emit(
                              "open-appointment-restrictions",
                              _vm.lpuAddress.lpu
                            )
                          },
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _setup.workplaces.length || _setup.services.length
                    ? _c(_setup.WorkplaceOrServiceSelect, {
                        staticClass: "mt-6",
                        attrs: {
                          label: _setup.t(
                            "Специальность или услуга",
                            _setup.options
                          ),
                          "lpu-id": _vm.lpuAddress.lpu.id,
                          "data-lpu-addr-id": _vm.lpuAddress.id,
                          "init-speciality-translit":
                            _setup.doctor.spec.translit,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(_setup.DoctorPriceBlock, {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _setup.filterType !== "home",
                        expression: "filterType !== 'home'",
                      },
                    ],
                    staticClass: "mt-4",
                    attrs: {
                      "page-type": _setup.filterType,
                      price:
                        _setup.selectedItemPriceList[
                          _setup.defaultPricePropertyName
                        ],
                      "club-price": _setup.selectedItemPriceList.priceClub,
                      "telemed-medtochka-price":
                        _setup.selectedItemPriceList.priceMedtochkaTelemed,
                      "tab-is-free-with-treatment":
                        _setup.selectedItem.workplace
                          ?.tab_is_free_with_treatment,
                      "speciality-selected": "",
                    },
                    on: {
                      "update:redirect-value":
                        _setup.handlePriceBlockUpdateRedirectValue,
                    },
                  }),
                  _vm._v(" "),
                  _vm.lpuAddress.lpu.lpu_loyalty_program &&
                  _setup.filterType === "clinic"
                    ? _c(_setup.LpuLoyaltyProgram, {
                        staticClass: "mt-3",
                        attrs: {
                          "bonus-levels":
                            _vm.lpuAddress.lpu.lpu_loyalty_program.levels,
                          "max-payment-percent":
                            _vm.lpuAddress.lpu.lpu_loyalty_program
                              .max_payment_percent,
                          "welcome-bonus-amount":
                            _vm.lpuAddress.lpu.lpu_loyalty_program
                              .welcome_bonus_amount,
                          "use-label": "",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _setup.filterType !== "telemed"
                    ? [
                        _c(
                          "div",
                          {
                            directives: [
                              { def: Ripple, name: "ripple", rawName: "v-ripple" },
                            ],
                            staticClass:
                              "d-flex align-center text-body-1 primary--text py-2 cursor-pointer mt-4",
                            on: { click: _setup.handlePopupMapButtonClick },
                          },
                          [
                            _c(
                              VIcon,
                              {
                                staticClass: "mr-4",
                                attrs: { size: "20", color: "icon-secondary" },
                              },
                              [
                                _vm._v(
                                  "\n            ui-icon-map-pin\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _setup.isUserStaff
                              ? [
                                  _c("div", [
                                    _c("span", { staticClass: "text--text" }, [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.lpuAddress.lpu.town.translit !==
                                              _setup.townTranslit
                                              ? `${_setup.props.lpuAddress.lpu.town.name},`
                                              : ""
                                          ) +
                                          "\n              "
                                      ),
                                    ]),
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _setup.transDynamic(
                                            _vm.lpuAddress,
                                            `address,${_setup.currentLanguageIso},${_setup.needTranslate}`
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]),
                                ]
                              : [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_setup.fullAddress) +
                                      "\n          "
                                  ),
                                ],
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _vm.lpuAddress.lpu.lpumetro_set.all.length
                          ? _c(_setup.DoctorPageLpuListMetroList, {
                              staticClass: "mt-2",
                              attrs: { "lpu-address": _vm.lpuAddress },
                            })
                          : _vm._e(),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c(_setup.DoctorPageLpuListPhone, {
                    attrs: { "lpu-address": _vm.lpuAddress },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(VSpacer),
              _vm._v(" "),
              _c(
                VSheet,
                { attrs: { width: "389" } },
                [
                  _setup.workplaces.length || _setup.services.length
                    ? _c(_setup.WorkplaceOrServiceCalendar, {
                        attrs: { "lpu-address": _vm.lpuAddress },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }